import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconSquareBehindSquare3"><Path fillRule="evenodd" clipRule="evenodd" d="M16 8V2.75C16 2.33579 15.6642 2 15.25 2H2.75C2.33579 2 2 2.33579 2 2.75V15.25C2 15.6642 2.33579 16 2.75 16H8V21.25C8 21.6642 8.33579 22 8.75 22H21.25C21.6642 22 22 21.6642 22 21.25V8.75C22 8.33579 21.6642 8 21.25 8H16ZM15.25 16C15.6642 16 16 15.6642 16 15.25V9.5H20.5V20.5H9.5V16H15.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare3;
